import { useEffect, useState } from "react";
import { getTeamMemberAditionalDaysTable } from "../../../../../services/vacation.service";

/**
 * Hook para obtener la información de los días adicionales
 * de un integrante del equipo dentro de un periodo definido.
 *
 * @param {Object} param0 - Parámetros del hook.
 * @param {string} param0.teamMemberId - ID del integrante del equipo.
 * @param {string} param0.periodStartDate - Fecha de inicio del periodo (ISO).
 * @param {string} param0.periodEndDate - Fecha de fin del periodo (ISO).
 * @returns {{
 *   additionalDays: TeamMemberAdditionalDayOff[],
 *   isLoading: boolean
 * }} - Días adicionales y estado de carga.
 */
export default function useFetchTeamMemberVacationsAditional({
  teamMemberId = undefined,
  periodStartDate = undefined,
  periodEndDate = undefined,
  refresh = undefined
}) {
  const [additionalDays, setAdditionalDays] = useState(
    /** @type {TeamMemberAdditionalDayOff[]} */ ([])
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;

    if (isMounted && periodStartDate && periodEndDate) {
      fetchAdditionalDays();
    }

    return () => {
      isMounted = false;
    };
  }, [teamMemberId, periodStartDate, periodEndDate, refresh]);

 
  async function fetchAdditionalDays() {
    if (isLoading) return;

    try {
      setIsLoading(true);

      const { success, result } = await getTeamMemberAditionalDaysTable(
        periodStartDate,
        periodEndDate,
        teamMemberId
      );

      if (!success) return;

    
  
      setAdditionalDays(result);
    } catch (error) {
      console.error("Error fetching additional days:", error);
    } finally {
      setIsLoading(false);
    }
  }

  return { additionalDays, isLoading };
}

/**
 * @typedef {Object} TeamMemberAdditionalDayOff
 * @property {number} availableDays - Cantidad de días disponibles.
 * @property {number} takenDays - Cantidad de días tomados.
 * @property {string} motive - Motivo del día adicional.
 * @property {string} expirationDate - Fecha de vencimiento (ISO).
 * @property {string} createdAt - Fecha de creación / asignación (ISO).
 * @property {string} type - Tipo de día (EXTRA).
 */